import { type Sound, SoundPlayer } from './SoundPlayer'
import type { Storage } from '@/infra/storage'

/**
 * Plays the given sound, stops if the signal aborts.
 */
export type PlaySoundFn = (sound: Sound, signal?: AbortSignal) => unknown

/**
 * Options for the {@link SoundFeature}.
 */
export interface SoundFeatureOptions {
  storage: Storage
}

/**
 * Everything related to playing sounds.
 */
export type SoundFeature = ReturnType<typeof SoundFeature>

export function SoundFeature(options: SoundFeatureOptions) {
  // Not using an internal module loader here because we want to
  // load sounds once the user has interacted with the page, and we
  // need to do that immediately in the same frame as the user interaction.
  const soundPlayer = new SoundPlayer(options.storage)

  return {
    // Public
    playSound: soundPlayer.playSound,
  }
}

export type { Sound }
